module.exports = __webpack_public_path__ + "img/fogg-success-1.04427fa3.svg";